const tooltips = {
  activity: (
    <>
      <p>Select the Activity type from dropdown list. Options include:</p>
      <p>
        <span className='text-bold'>
          Conversion of waters type (e.g., forested wetland to emergent wetland, stream to lake, etc.)
        </span>{' '}
        - Enter area or linear distance of any fill amounts in area or linear units. Examples include: Wetland
        vegetation maintained in perpetuity using herbicide after authorizing the placement of radio tower arrays in
        wetland (e.g., conversion from a forested wetland to a scrub shrub wetland). Enter the amount of scrub shrub in
        conversion amount. Conversion of wetland type for a utility line installation (this situation occurs when there
        is no restoration of the forested wetland over the new utility line because of potential future tree root damage
        to the utility line and the need for emergency access and maintenance.
      </p>
      <p>
        <span className='text-bold'>Discharge of dredged material</span> - Any addition of dredged material into,
        including redeposit of dredged material other than incidental fallback within, the waters of the United States.
        The regulation includes specific examples of what this term includes 33 CFR 323.2(d)(1)(i-iii) and does not
        include 33 CFR 323.2(d)(2).
      </p>
      <p>
        <span className='text-bold'>Discharge of fill material</span> – The addition of fill material into waters of the
        U.S. The term generally includes, without limitation, the following activities: Placement of fill that is
        necessary for the construction of any structure or infrastructure in a water of the United States; the building
        of any structure, infrastructure, or impoundment requiring rock, sand, dirt, or other material for its
        construction; site-development fills for recreational, industrial, commercial, residential, or other uses;
        causeways or road fills; dams and dikes; artificial islands; property protection and/or reclamation devices such
        as riprap, groins, seawalls, breakwaters, and revetments; beach nourishment; levees; fill for structures such as
        sewage treatment facilities, intake and outfall pipes associated with power plants and subaqueous utility lines;
        placement of fill material for construction or maintenance of any liner, berm, or other infrastructure
        associated with solid waste landfills; placement of overburden, slurry, or tailings or similar mining-related
        materials; and artificial reefs. (33 CFR 323.2(f)).
      </p>
      <p>
        <span className='text-bold'>Dredging (Section 10)</span> - Enter area of area to be dredged and the volume of
        dredged material removed.
      </p>
      <p>
        <span className='text-bold'>Ecological restoration</span> - Used for Nationwide permit 27 data entry (and some
        other regional general permits). If the verified permit is a stream or wetland establishment, reestablishment,
        rehabilitation, and/or enhancement activity or stream restoration project, enter the area or linear amounts for
        any fill or restored amount. This does NOT include voluntary restoration done as part of an unauthorized
        activity.
      </p>
      <p>
        <span className='text-bold'>Removal (Sec 10 structures)</span> - Use this field to enter area or linear values
        for any Section 10 structures that are being removed. This field IS NOT to be used to record the removal of fill
        material (either authorized or unauthorized).
      </p>
      <p>
        <span className='text-bold'>Structure (Sec 10 only)</span> - An object that is arranged in a definite pattern of
        organization. Examples of structures include, without limitation, any pier, boat dock, boat ramp, wharf,
        dolphin, weir, boom, breakwater, bulkhead, revetment, riprap, jetty, artificial island, artificial reef,
        permanent mooring structure, power transmission line, permanently moored floating vessel, piling, aid to
        navigation, or any other manmade obstacle or obstruction. (33 CFR 322.2(b)). Enter area or linear value for the
        structure proposed to be authorized.
      </p>
      <p>
        <span className='text-bold'>Transport of dredged material (Sec 103)</span> - Enter fill volume.
      </p>
      <p>
        <span className='text-bold'>Other (Aquaculture, Work, Aerial or Submarine cable crossings)</span> - Enter the
        fill or removal area or removal linear value as appropriate. Be careful to distinguish between temporary versus
        permanent impacts. This impact activity type can also be used for many aquaculture projects in Section 10 waters
        where cages, pens, etc. are used. 'Work' (maintenance/replacement activities with no new fill or additional
        structures) where the footprint remains the same is not considered a loss.
      </p>
    </>
  ),

  amountType: 'The options here are Fill Area or Removal Area and Removal Volume based on your Activity type.',

  areaUnits:
    'Corresponds to the Proposed Area Amount.  Unit type depends on Amount Type selected.  Will automatically defer to square feet if you enter a length and width.',

  proposedArea:
    'Area will automatically be calculated if a length and width are provided.  Enter the area of impact here.',

  proposedLength:
    'Enter the length of the proposed impact. This is generally used for stream or linear wetland impacts.',

  proposedWidth:
    'Enter the width of the proposed impact. This is generally used for stream or linear wetland impacts when a length is entered. Note: The following calculation applies only when the "River/Stream" resource type is selected. If the stream\'s surface area has been surveyed, the average width can be easily calculated using the formula: Average Width = Surface Area / Length',

  compensatoryMitigation: (
    <>
      Compensatory mitigation is required for wetland losses greater than 1/10 Ac or stream losses greater than 3/100 Ac
      at a minimum of a 1:1 ratio unless the USACE district determines that 1) another form of mitigation is
      appropriate, 2) the impacts are minimal, or 3) an activity specific waiver is warranted. For losses that exceed
      these thresholds, describe the proposed compensatory mitigation proposed or why compensatory mitigation should not
      be required. Since streams are difficult-to-replace resources, the compensatory mitigation requirement may be
      satisfied through the rehabilitation, enhancement, or preservation of streams, or the restoration or enhancement
      of riparian areas next to streams.{' '}
    </>
  ),

  impactName: (
    <>
      <div className='margin-bottom-1'>
        Give a unique impact name to each impact entered. Unique names help distinguish one impact from another and can
        contain information about the aquatic resource or type of activity.
      </div>
      <div className='text-bold'>Examples:</div>
      <div>Impact 1 – Culvert,</div>
      <div>Impact 2 – Construction Equipment Access,</div>
      <div>Impact 3 – Sewer Line</div>
    </>
  ),

  impactWidth: (
    <>
      <p className='text-italic'>
        Note: The following calculation applies only when the "River/Stream" resource type is selected.
      </p>
      <p>
        If the stream's surface area has been surveyed, the average width can be easily calculated using the formula:
      </p>
      <div className='text-bold text-center padding-1 bg-base-lightest'>Average Width = Surface Area / Length</div>
    </>
  ),

  mitigationType: (
    <>
      <p>
        <span className='text-bold'>Mitigation Bank</span> means a site, or suite of sites, where resources (e.g.,
        wetlands, streams, riparian areas) are restored, established, enhanced, and/or preserved for the purpose of
        providing compensatory mitigation for impacts authorized by Department of the Army permits. In general, a
        mitigation bank sells compensatory mitigation credits to permittees whose obligation to provide compensatory
        mitigation is then transferred to the mitigation bank sponsor. The operation and use of a mitigation bank are
        governed by a mitigation banking instrument.
      </p>
      <p>
        <span className='text-bold'>In-lieu fee (ILF) Program</span> means a program involving the restoration,
        establishment, enhancement, and/or preservation of aquatic resources through funds paid to a governmental or
        non-profit natural resources management entity to satisfy compensatory mitigation requirements for Department of
        the Army permits. Similar to a mitigation bank, an in-lieu fee program sells compensatory mitigation credits to
        permittees whose obligation to provide compensatory mitigation is then transferred to the in-lieu program
        sponsor. However, the rules governing the operation and use of in-lieu fee programs are somewhat different from
        the rules governing operation and use of mitigation banks. The operation and use of an in-lieu fee program are
        governed by an in-lieu fee program instrument.
      </p>
      <p>
        <span className='text-bold'>Permitee-responsible mitigation (PRM)</span> means an aquatic resource restoration,
        establishment, enhancement, and/or preservation activity undertaken by the permittee (or an authorized agent or
        contractor) to provide compensatory mitigation for which the permittee retains full responsibility.
        <span className='text-bold'>
          {' '}
          Applicant must follow 33 CFR 332.4 when developing conceptual and final mitigation proposals.
        </span>
      </p>
      <p>
        <span className='text-bold'>Advanced Permittee Responsible Mitigation</span> - APRM is a form of
        permittee-responsible mitigation (PRM) constructed in advance of permitted impacts to aquatic resources. All
        APRM sites must comply with the standards and requirements of the 2008 Mitigation Rule.
      </p>
    </>
  ),

  permitteeResponsibleMitigationType: (
    <>
      <p>
        <span className='text-bold'>Establishment</span> (creation) means the manipulation of the physical, chemical, or
        biological characteristics present to develop an aquatic resource that did not previously exist at an upland
        site. Establishment results in a gain in aquatic resource area and functions.{' '}
      </p>
      <p>
        <span className='text-bold'>Re-establishment</span> means the manipulation of the physical, chemical, or
        biological characteristics of a site with the goal of returning natural/historic functions to a former aquatic
        resource. Re-establishment results in rebuilding a former aquatic resource and results in a gain in aquatic
        resource area and functions.{' '}
      </p>
      <p>
        <span className='text-bold'>Enhancement</span> means the manipulation of the physical, chemical, or biological
        characteristics of an aquatic resource to heighten, intensify, or improve a specific aquatic resource
        function(s). Enhancement results in the gain of selected aquatic resource function(s) but may also lead to a
        decline in other aquatic resource function(s). Enhancement does not result in a gain in aquatic resource
        area.{' '}
      </p>
      <p>
        <span className='text-bold'>Rehabilitation</span> means the manipulation of the physical, chemical, or
        biological characteristics of a site with the goal of repairing natural/historic functions to a degraded aquatic
        resource. Rehabilitation results in a gain in aquatic resource function but does not result in a gain in aquatic
        resource area.{' '}
      </p>
      <p>
        <span className='text-bold'>Preservation</span> means the removal of a threat to, or preventing the decline of,
        aquatic resources by an action in or near those aquatic resources. This term includes activities commonly
        associated with the protection and maintenance of aquatic resources through the implementation of appropriate
        legal and physical mechanisms. Preservation does not result in a gain of aquatic resource area or functions.
      </p>
    </>
  ),

  proposedMitigation:
    'Provide a brief explanation describing how impacts to waters of the United States are being avoided and minimized on the project site. Also provide a brief description of how impacts to waters of the United States will be compensated for, or a brief statement explaining why compensatory mitigation should not be required for those impacts',

  typeOfMaterials:
    'Describe the material to be discharged within USACE jurisdiction. Please be sure this description will agree with your illustrations. Examples of such fill material include, but are not limited to rock, sand, soil, clay, plastics, construction debris, wood chips, overburden from mining or other excavation activities, and materials used to create any structure or infrastructure in the waters of the United States. (33 CFR 323.2(e)).',

  resourceType:
    'Select the Resource Type from drop down list. Options are Harbor/Ocean, Lake, Non-Tidal Wetland, Other, Pond, River/Stream, and Tidal wetland.',

  impactDuration:
    'Enter "Permanent" or "Temporary" from the drop down list. An example of a temporary impact is the discharge of fill for temporary access roads that are later removed and returned to pre-construction contours.',

  permanentLoss: (
    <>
      <p>
        Permanent losses occur when a discharge of dredged or fill material changes an aquatic resource or a portion of
        an aquatic resource (e.g., wetland, stream, pond, deepwater habitat), to a non-aquatic resource (i.e., upland or
        dry land). The activity results in permanent loss of that aquatic resource in terms of area and function.
        Conversion of one aquatic resource type to another is not considered a “permanent loss as some values and
        functions may remain.
      </p>
      <p>
        This differs slightly from the Nationwide Permit definition of permanent losses. The broader NWP Program
        definition of "loss of WOTUS" below is intended to ensure that NWP activities result only in minimal individual
        and cumulative effects on the aquatic environment and incorporates threshold requirements.{' '}
      </p>
      <p>
        Waters of the United States that are permanently adversely affected by filling, flooding, excavation, or
        drainage because of the regulated activity. The loss of stream bed includes the acres of stream bed that are
        permanently adversely affected by filling or excavation because of the regulated activity. Permanent adverse
        effects include permanent discharges of dredged or fill material that change an aquatic area to dry land,
        increase the bottom elevation of a waterbody, or change the use of a waterbody. The acreage of loss of waters of
        the United States is a threshold measurement of the impact to jurisdictional waters or wetlands for determining
        whether a project may qualify for an NWP; it is not a net threshold that is calculated after considering
        compensatory mitigation that may be used to offset losses of aquatic functions and services. Waters of the
        United States temporarily filled, flooded, excavated, or drained, but restored to pre-construction contours and
        elevations after construction, are not included in the measurement of loss of waters of the United States.
        Impacts resulting from activities that do not require Department of the Army authorization, such as activities
        eligible for exemptions under Section 404(f) of the Clean Water Act, are not considered when calculating the
        loss of waters of the United States.
      </p>
    </>
  ),

  waterName:
    'Pick list of previously entered Aquatic Resources that would be impacted.  Each aquatic resource may have multiple impacts and a project may have several aquatic resources.',

  willResultInWetlandLossLabel: `National thresholds include losses greater than 1/10 acre of wetland or 3/100 acre of stream. Districts or states may have smaller thresholds. Please contact your local district with any questions.
[Nationwide Permit Info] (https://www.usace.army.mil/Missions/Civil-Works/Regulatory-Program-and-Permits/Nationwide-Permits/) (Specifically, Nationwide Permit General Condition Number 23.)`,
};

export default tooltips;
